class PreviewStore {
  private _isPreviewMode = false;
  private listeners = new Set<() => void>();

  constructor() {
    // Detect preview mode from URL parameters
    const params = new URLSearchParams(window.location.search);
    this._isPreviewMode = params.get("preview") === "true";
  }

  get isPreviewMode() {
    return this._isPreviewMode;
  }

  subscribe(callback: () => void) {
    this.listeners.add(callback);
    return () => this.listeners.delete(callback);
  }

  private notifyListeners() {
    this.listeners.forEach((callback) => callback());
  }
}

export const previewStore = new PreviewStore();
